<i18n>
  {
    "en_US": {
      "join": "Join the event",
      "participantName": "Enter your name or another guest's name",
      "helpText": "Add participants to your event or, if you are a guest, enter your name to begin adding items!"
    },
    "fr_FR": {
      "join": "Ajouter un participant",
      "participantName": "Entrez votre nom ou celui d'un autre invité",
      "helpText": "Ajoutez des participants à votre évènement ou, si vous êtes un invité, entrez votre nom pour commencer à ajouter des items !"
    }
  }
</i18n>

<template>
  <div>
    <div class="field has-addons">
      <p class="control is-expanded">
        <input class="input" v-model="userName" :placeholder="$t('participantName')" @keyup.enter="addUser">
      </p>

      <p class="control">
        <b-tooltip
          :label="$t('helpText')"
          position="is-left"
          type="is-dark"
          multilined
        >
          <a class="button">
            <span class="icon is-right has-text-info"><i class="fa fa-info-circle"></i></span>
          </a>
        </b-tooltip>
      </p>
    </div>

    <div class="field is-grouped is-grouped-centered">
      <div class="control">
        <button class="button is-primary" @click="addUser" :class="{ 'is-loading': isLoading }" :disabled="userName.trim() === '' || isLoading">
          <span class="icon is-small"><i class="fa fa-plus"></i></span>
          <span>{{ $t('join') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { getEventById } from '@/shared/queries'

  const uuidv4 = require('uuid/v4')

  const createUser = gql`
    mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!]) {
      createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds) {
        id
        name
      }
    }
  `

  export default {
    name: 'user-form',
    data () {
      return {
        userName: '',
        isLoading: false
      }
    },
    props: ['event-id'],
    methods: {
      addUser: function () {
        this.isLoading = true

        this.$apollo.mutate({
          mutation: createUser,
          variables: {
            name: this.userName,
            secret: uuidv4(),
            attendedEventsIds: [this.eventId]
          },
          refetchQueries: [{
            query: getEventById,
            variables: {
              id: this.eventId
            }
          }]
        }).then(() => {
          this.userName = ''
        }).catch((error) => {
          this.$ga && this.$ga.exception(error.message || error)
        }).then(() => {
          this.isLoading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UserForm.vue